module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-block module-block-recapitulative vanguard-order-recap-container"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('billingRecap.title')))]), _vm._v(" "), _vm._l((_vm.choices), function(choice) {
    return _c('div', {
      key: ("choice-" + (choice.id))
    }, [_c('div', {
      staticClass: "row module-block-offer-choice-name"
    }, [_c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.choiceName')))])]), _vm._v(" "), (choice.description) ? _c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-10"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(choice.description)
      }
    }), _vm._v(" "), (choice.name) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n          ("), _c('span', {
      staticClass: "font-italic"
    }, [_vm._v(_vm._s(_vm.$t('billingRecap.choiceCode')) + ": "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(choice.name)
      }
    })]), _vm._v(")\n        ")]) : _vm._e()]) : _c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-10"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(choice.name)
      }
    })])]), _vm._v(" "), (choice && choice.longDescription) ? _c('div', {
      staticClass: "row module-block-offer-long-description"
    }, [_c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.description')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-10",
      domProps: {
        "innerHTML": _vm._s(choice.longDescription)
      }
    })]) : _vm._e(), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticClass: "row module-block-payment-at-order-time module-block-recapitulative-max-width pt-2"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('billingRecap.paymentAtOrderTime')))])])]), _vm._v(" "), _vm._l((_vm.choices), function(choice) {
    return _c('div', {
      key: ("choice-price-" + (choice.id))
    }, [_c('div', {
      staticClass: "row module-block-offer-price module-block-recapitulative-max-width"
    }, [_c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-8"
    }, [(choice.description) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(choice.description)
      }
    }) : (choice.name) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(choice.name)
      }
    }) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.price')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
    }, [_c('span', [_vm._v(_vm._s(_vm.presentFloat(choice.price)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row module-block-offer-total module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-8"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('billingRecap.orderTotal')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap font-weight-bold"
  }, [_c('amount-total', {
    attrs: {
      "force-float": true
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])], 1)]), _vm._v(" "), (_vm.paymentMethod) ? _c('div', {
    staticClass: "row module-block-offer-choice-payment-method module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.paymentMethod')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
  }, [_vm._v("\n      " + _vm._s(_vm.Utils.capitalizeFirstLetter(_vm.$t('all.' + _vm.paymentMethod))) + "\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa40f90","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/multiple/components/order-recap.vue
// module id = 996
// module chunks = 0